export function isNLAPluginSignUp(utmCampaign: string | string[] | undefined) {
  return Array.isArray(utmCampaign)
    ? utmCampaign[0] === 'openai'
    : utmCampaign === 'openai';
}
